import { useState, useEffect } from "react";
import TabSwitch from "../TabSwitch";
import beta from './beta.png';
import VtksSaudadesFont from '../../assets/fonts/Vtks-Saudades.ttf';



export default function SelfHostHeader() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isTransferDropdownOpen, setIsTransferDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTransferDropdownOpenMobile, setIsTransferDropdownOpenMobile] = useState(false);

  useEffect(() => {

    // First visit cookie logic
    const isFirstVisit = document.cookie.indexOf("firstVisit=true") === -1;
    if (isFirstVisit) {
      setIsMenuOpen(true);
      document.cookie = "firstVisit=true; path=/; max-age=" + 60 * 60 * 24 * 30;
    }

    let closeMenuTimeout;
    if (isFirstVisit) {
      closeMenuTimeout = setTimeout(() => {
        setIsMenuOpen(false);
      }, 1000);
    }

    // Click outside handler
    const handleClickOutside = (event) => {
      const target = event.target;
      if (
        !target.closest(".dropdown-menu") &&
        !target.closest(".transfer-trigger") &&
        !target.closest(".more-trigger") &&
        !target.closest(".slide-menu") &&
        !target.closest(".hamburger")
      ) {
        setIsDropdownOpen(false);
        setIsTransferDropdownOpen(false);
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    // Cleanup
    return () => {
      window.removeEventListener("click", handleClickOutside);
      if (closeMenuTimeout) clearTimeout(closeMenuTimeout);
    };
  }, []);

  return (
    <>
      <style>
        {`
        @font-face {
          font-family: 'VtksSaudades';
          src: url(${VtksSaudadesFont}) format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }

        .vtks-saudades {
          font-family: 'VtksSaudades' !important;
          font-size: 20px !important;
        }
        .navbar {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: transparent;
          padding: 20px 50px;
         border-bottom: 2px solid #ddd;
          z-index: 1000;
        }
          .navbar-left a{
          display: flex;
          align-items: end;
          gap: 3px;
          }

       

        .navbar-center {
          flex: 2;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .navbar-center ul {
          display: flex;
          align-items: center;
          gap: 20px;
          list-style: none;
          padding: 0;
          margin: 0;
          align-items: baseline;
        }

        .li {
          list-style: none;
        }

        .navbar-center li {
          position: relative;
          cursor: pointer;
        }

        .navbar-center a {
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font-size: 15px;
        }

        .dropdown-menu {
          display: none !important;
          position: absolute;
          top: 100%;
          left: 0;
          background: #12A500;
          color: white;
          list-style: none;
          padding: 10px 0;
          border: none;
          min-width: 150px;
          border-radius: 4px;
          box-shadow: rgba(112, 112, 112, 0.2) 0px 2px 8px 0px;
          z-index: 1000;
        }

        .transfer-dropdown-menu {
          display: none !important;
          position: absolute;
          top: 100%;
          left: 0;
          background: #050520;
          color: white;
          list-style: none;
          padding: 10px 0;
          border: none;
          min-width: 150px;
          border-radius: 4px;
          box-shadow: rgba(112, 112, 112, 0.2) 0px 2px 8px 0px;
          z-index: 1000;
          border: 1px solid white;
        }

        .dropdown-menu.show {
          display: block !important;
        }

        .transfer-dropdown-menu.show {
          display: block !important;
        }

        .dropdown-menu li a {
          display: block;
          padding: 8px 15px;
          color: white;
          text-decoration: none;
          text-transform: uppercase;
        }

        .transfer-dropdown-menu li a {
          display: block;
          padding: 8px 15px;
          color: white;
          text-decoration: none;
          text-transform: uppercase;
        }

        .navbar-right {
          width: 120px;
          display: flex;
          justify-content: flex-end;
        }

        .hamburger {
          display: none;
          cursor: pointer;
          width: 30px;
        }

        .hamburger div {
          width: 100%;
          height: 2px;
          background: #0080FF;
          margin: 3px 0;
        }

        .slide-menu {
          position: fixed;
          right: -180px;
          top: 0;
          height: 100%;
          width: 180px;
          background-color: #12A500;
          transition: right 2s ease-in-out;
          z-index: 9999;
          box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        }

        .slide-menu.open {
          right: 0;
        }

        .slide-menu a {
          font-size: 14px;
          display: block;
          color: white;
          text-transform: uppercase;
          margin: 8px 0;
          text-decoration: none;
        }

        .active-nav-link {
          font-size: 16px;
          font-weight: bold;
          border-bottom: 2px solid white;
          padding-bottom: 8px;
        }

        .dropdown-arrow {
          transition: transform 0.3s ease;
        }

        .dropdown-arrow.rotated {
          transform: rotate(180deg);
        }

        /* Responsive adjustments */
        @media (max-width: 426px) {
          .navbar {
            padding: 10px 10px;
            justify-content: center;
          }
          .slide-menu {
            background-color: rgba(255, 255, 255, 0.98);
            transition: all 0.6s ease-in-out;
            left: -180px;
            right: auto;
          }
          .slide-menu.open {
            left: 0;
          }
          .navbar-center ul {
            gap: 10px;
          }

          .navbar-center a {
            font-size: 11px;
          }

          /* Hide Notes and Transfer in main navbar, show in dropdown */
          .desktop-only {
            display: none;
          }

          .mobile-only {
            display: flex !important;
          }

          .dropdown-menu li a {
            padding: 6px 12px;
            font-size: 13px;
          }

          .dropdown-menu {
            top: 90%;
          }
          .hamburger {
          opacity: 0;
            width: 24px;
          }
          .navbar-left a {
            font-size: 23px !important;
            opacity: 0;
          }
        }

        /* Desktop - show normally */
        @media (min-width: 426px) {
          .mobile-only {
            display: none !important;
          }
        }

        .mobile-sidebar {
            width: 100%;
            height: 100%;
            background-color: #050520;
            padding: 0 10px;
          }

          .sidebar-header {
            padding: 5px 0 10px;
            border-bottom: 1px solid #eee;
            margin-bottom: 20px;
          }

          .sidebar-header h2 {
          font-family: 'Sometype Mono', monospace;
            color: #ffffff;
            font-size: 21px;
            font-weight: bold;
            margin: 0;
            padding: 5px 0px 20px 0px;
          }

          .sidebar-menu {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }

          .sidebar-link {
            color: white;
            text-decoration: none;
            font-size: 12px;
            padding: 6px 8px;
            border-radius: 6px;
            transition: all 0.3s ease;
          }

          .sidebar-link:hover {
            background-color: #f5f5f5;
          }

          .sidebar-link.active {
            background-color: #12A500;
            color: white;
            font-weight: bold;
          }
          .close-btn {
           position: absolute;
            background-color: #12A500;
            color: #050520;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            top: 16px;
            right: -40px;
            font-size: 30px;
            transform: rotate(270deg);
            cursor: pointer;
            transition: transform 0.3s ease;
        }

          .close-btn-open {
            position: absolute;
            background-color: #12A500;
            color: #050520;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            top: 16px;
            right: -10px;
            font-size: 30px;
            transform: rotate(90deg);
            cursor: pointer;
            transition: transform 0.3s ease;
          }

          

      @media (max-width: 570px) {
        .navbar{
        padding: 10px 15px;
        }
        .navbar-left a{
          font-size: 20px !important;
        }
          
          .navbar-center ul {
          gap: 10px;
          
          }
          .navbar-center a {
            font-size: 12px;
          }
        }
          .hidden-options {
  display: none; /* or visibility: hidden; */
}
      `}
      </style>
      <header>
        <nav className="navbar">
          <div className="navbar-left desktop-only">
            <a
              href="#"
              style={{
                fontFamily: 'Sometype Mono',
                color: "#12A500",
                textDecoration: "none",
                fontSize: "28px",
                fontWeight: "bold",
              }}
            >
              <span style={{color: "white"}}>S3ND / </span> P2P <img  src={beta} alt="beta" style={{height: '25px'}}  />
            </a>
          </div>

          <div className="navbar-center desktop-only">
            <ul>
              <li>
                <a href="https://0.rw/">N∅te</a>
              </li>
              <li>
                <a href="https://1.rw/" rel="noopener noreferrer">
                  L1NK
                </a>
              </li>
              <li className="desktop-only">
                <a href="https://2.rw/" rel="noopener noreferrer">
                  DOCƧ
                </a>
              </li>
               <li className=" active-nav-link transfer-trigger">
                <a
                  href="https://3.rw"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    // Only navigate if not clicking the arrow
                    if (e.target.closest(".toggle-arrow")) {
                      e.preventDefault(); // Block navigation on arrow click
                    }
                  }}
                >
                  <a href="https://3.rw" >S3ND</a>

                 
                </a>

                <ul
                  className={`transfer-dropdown-menu ${
                    isTransferDropdownOpen ? "show" : ""
                  }`}
                >
                  <li>
                    <a style={{ fontWeight: "normal" }} href="#">
                      P2Psend
                    </a>
                  </li>
                  <li>
                    <a
                      style={{ fontWeight: "normal" }}
                      href="https://0.rw/2/"
                      rel="noopener noreferrer"
                    >
                      CLOUDsend
                    </a>
                  </li>
                </ul>
              </li>
              
              
             
              
              <li className="desktop-only">
                <a href="https://4.rw/" rel="noopener noreferrer">
                  M4IL
                </a>
              </li>
              <li className="desktop-only">
                <a  href="https://5.rw/" rel="noopener noreferrer">
                  R55
                </a>
              </li>
            </ul>
          </div>

          <div className="navbar-right desktop-only" style={{opacity: 0}}>
            <div
              className="hamburger"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            ></div>
          </div>
          <div className="container flex mx-auto sm:hidden justify-center mobile-only">
     <TabSwitch />
     </div>
        </nav>

        <div className={`mobile-only slide-menu ${isMenuOpen ? "open" : ""}`}>
          <div
            className={`${isMenuOpen ? "close-btn-open" : "close-btn"}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span>
              <svg
                className={`dropdown-arrow ${isDropdownOpen ? "rotated" : ""}`}
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </span>
          </div>
          <aside className="mobile-sidebar">
            <div className="sidebar-header">
              <h2 style={{display: 'flex', gap: '3px'}}>S3ND/<span style={{color: "#12A500"}}>P2P</span> <img src={beta} style={{height: '25px'}} /></h2>
              <p style={{ color: "#12A500", "text-align": "center" }}>
                Other Services
              </p>
            </div>
            <nav className="sidebar-menu">
              <a href="https://0.rw" class="sidebar-link">
                N∅te
              </a>
              <a href="https://1.rw" class="sidebar-link">
                L1NK
              </a>
               <a href="https://2.rw" className="sidebar-link">
                DOCƧ
              </a>
               <a
                href="https://3.rw"
                className="sidebar-link active"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "5px",
                }}
                onClick={(e) => {
                  // Only navigate if NOT clicking on the icon
                  if (e.target.closest(".toggle-arrow")) {
                    e.preventDefault(); // prevent navigating if arrow clicked
                  }
                }}
              >
                <span>S3ND</span>
                <span
                  className="toggle-arrow"
                  onClick={(e) => {
                    e.preventDefault(); // prevent <a> from navigating
                    e.stopPropagation(); // prevent outer onClick from firing
                    setIsTransferDropdownOpenMobile(
                      !isTransferDropdownOpenMobile
                    );
                  }}
                >
                  
                </span>
              </a>
              

             
              

             
               <a href="https://4.rw" className="sidebar-link">
                M4IL
              </a>
               <a className=" sidebar-link"  href="https://5.rw" >
                R55
              </a>
            </nav>
          </aside>
        </div>
      </header>
    </>
  );
}
